"use client";

import { useRouter } from "next/navigation";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { useTranslations } from "next-intl";

export default function GoBackButton() {
  const router = useRouter();
  const t = useTranslations("Components.navigation");

  return (
    <button
      onClick={() => router.back()}
      className="flex flex-row text-nowrap justify-center items-center gap-2 rounded-sm px-5 py-2 w-min self-start hover:bg-primary-yellow bg-white text-background-grey cursor-pointer transition-colors"
    >
      <span>{t("backButton")}</span>
      <FontAwesomeIcon icon={faArrowLeft} />
    </button>
  );
}
